module.exports = __webpack_public_path__ + "0ecf2233f7ba17d91e42e4e23b2f4d6d.MP3";